import apiHandler from '../../api/core/apiHandler';
import { FiscalEvent } from '../../types/fiscal/FiscalEvent';
import { FiscalEventFilter } from '../../types/fiscal/FiscalEventFilter';
import { SpringPage } from '../../types/fiscal/ReturnEvent';
import { CustomResponse } from '../../types/api/CustomResponse';

const fiscalEventApi = apiHandler('dte/fiscal-events');

const FiscalEventService = {
  async getById(id: number): Promise<FiscalEvent> {
    return (await fiscalEventApi.fetchById(id)).data;
  },
  async findFiltered(
    filter: FiscalEventFilter,
    page = 0,
    size = 20,
    sort = 'createdAt,desc'
  ): Promise<CustomResponse<SpringPage<FiscalEvent>>> {
    const response = await fiscalEventApi.addCustom(`/filtered?page=${page}&size=${size}&sort=${sort}`, filter);
    return response.data;
  },
  async findByDte(dteId: number): Promise<FiscalEvent[]> {
    return (await fiscalEventApi.fetchCustom(`?dteId=${dteId}`)).data;
  },
  async findBySale(saleId: number): Promise<FiscalEvent[]> {
    return (await fiscalEventApi.fetchCustom(`?saleId=${saleId}`)).data;
  },
  async findByPurchase(purchaseId: number): Promise<FiscalEvent[]> {
    return (await fiscalEventApi.fetchCustom(`?purchaseId=${purchaseId}`)).data;
  },
  downloadPdf: (id: number) => fiscalEventApi.downloadBlobGet(`/${id}/pdf`, `evento-${id}.pdf`),
  downloadUnsignedJson: (id: number) => fiscalEventApi.downloadBlobGet(`/${id}/unsigned-json`, `evento-${id}-sin-firmar.json`, undefined, true),
  downloadSignedJson: (id: number) => fiscalEventApi.downloadBlobGet(`/${id}/signed-json`, `evento-${id}-firmado.json`, undefined, true),
  sendEmail: async (id: number) => {
    const response = await fiscalEventApi.addWithoutData(`/${id}/send-email`);
    return response.data;
  },
};

export default FiscalEventService;
